import { render, staticRenderFns } from "./assessmentAnalysis.vue?vue&type=template&id=97ec4b16&scoped=true"
import script from "./assessmentAnalysis.vue?vue&type=script&lang=js"
export * from "./assessmentAnalysis.vue?vue&type=script&lang=js"
import style0 from "./assessmentAnalysis.vue?vue&type=style&index=0&id=97ec4b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec4b16",
  null
  
)

export default component.exports